import {faPlus} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React from 'react';
import {Link} from 'react-router-dom';
import {RoutePatternsService} from '../api/generated/RoutePatternsService';
import {BasicPage} from '../components/basic-page';
import {
  PagedDataTableConfig,
  renderEditButton,
  usePagedDataTable,
} from '../hooks/paged-data-table/use-paged-data-table.tsx';
import {Button, Group} from '@mantine/core';
import {ROUTES} from '../routes';

export const RoutePatternListing = () => {
  const pagedDataTable = usePagedDataTable(
    RoutePatternsService.getAll,
    TableConfig,
    {
      renderActions: (
        <Button component={Link} to={ROUTES.ADMIN.ROUTE_PATTERNS.CREATE.path}>
          <Group gap={'xs'}>
            <FontAwesomeIcon icon={faPlus} /> New Route Pattern
          </Group>
        </Button>
      ),
    }
  );

  return <BasicPage title="Route Patterns">{pagedDataTable}</BasicPage>;
};

const TableConfig = PagedDataTableConfig(RoutePatternsService.getAll, {
  columns: [
    {
      accessor: 'actions',
      render: (item) =>
        renderEditButton({
          item: {...item, id: Number(item.id)},
          descriptor: 'Route Pattern',
          route: ROUTES.ADMIN.ROUTE_PATTERNS.DETAIL.path,
        }),
      width: '100px',
    },
    {
      accessor: 'description',
      sortable: true,
    },
    {
      accessor: 'pattern',
      sortable: true,
    },
  ],
  defaultSort: {
    column: 'description',
    direction: 'ASC',
  },
  searchFieldNames: ['description', 'pattern'],
});